export enum PaymentDeadlineStatus {
    UnderSixtyDays = 1,
    OverSixtyDays = 2,
    ExemptPayment = 3,
    UnderThirtyDays = 4,
    Undetermined = 5
}